import superUserRequest from 'utils/superUserRequest';

const createPlan = async (data) => {
  const response = await superUserRequest('POST', '/v1/plans/custom/', data);
  return response;
};

const updatePlan = async ({ slug, ...data }) => {
  const response = await superUserRequest('PATCH', `/v1/plans/custom/${slug}/`, data);
  return response;
};

const deletePlan = async (slug) => {
  const response = await superUserRequest('DELETE', `/v1/plans/custom/${slug}/`);
  return response;
};

const PLANS_MUTATIONS = {
  CREATE_PLAN: createPlan,
  UPDATE_PLAN: updatePlan,
  DELETE_PLAN: deletePlan,
};

export default PLANS_MUTATIONS;
